import {Prefab} from '../prefab.js';
import {AnimationGraph, Animation} from '../wonderland.js';

import {ResourceManager} from './resource.js';

/**
 * Manage animation graphs.
 *
 * #### Creation
 *
 * Creating an animation graph with a one dimensional
 * blend tree is done using {@link AnimationGraphManager.blend1D}
 *
 * @since 1.5.0
 */
export class AnimationGraphManager extends ResourceManager<AnimationGraph> {
    constructor(scene: Prefab) {
        super(scene, AnimationGraph);
    }

    /**
     * Generate an animation graph that blends between
     * a list of animation in 1 dimension.
     *
     * #### Usage
     *
     * ```js
     * const graph = engine.animationsGraphs.blend1D([idle, walk, run]);
     * object.getComponent(AnimationComponent).animation = graph;
     * ```
     *
     * @note All animations must have the same number of tracks
     * and only the first animation has to be retargeted to the object/skin.
     *
     * @param anims Array of anims to blend.
     * @returns The new animation graph.
     */
    blend1D(anims: Animation[]): AnimationGraph {
        if (anims.length <= 1) {
            throw new Error('At least 2 animations are required to create a blend graph.');
        }

        const wasm = this.engine.wasm;
        for (var i = 0; i < anims.length; ++i) {
            wasm._tempMemInt[i] = anims[i]._id;
        }
        const index = wasm._wl_animationGraph_create1DBlend(wasm._tempMem, anims.length);

        const instance = new AnimationGraph(this._host as Prefab, index);
        this._cache[instance.index] = instance;
        return instance;
    }
}
